// extracted by mini-css-extract-plugin
module.exports = {"Summary":"incidents_Summary__3Pyz3","DateCell":"incidents_DateCell__KIB-l"};